export const spacing = {
  // Base spacing scale
  xxs: "0.25em", // 4px
  xs: "0.5em", // 8px
  sm: "0.75em", // 12px
  md: "1em", // 16px
  lg: "1.5em", // 24px
  xl: "2em", // 32px
  xxl: "2.5em", // 40px
  xxxl: "3em", // 48px

  // Page specific values
  page: {
    paddingBottom: "7em",
    header: {
      title: {
        registeredMark: {
          fontSize: "0.4em",
        },
        fontSize: {
          default: "1.733em",
          desktop: "3em",
        },
        lineHeight: {
          default: "2em",
          desktop: "1.2em",
        },
        marginBottom: {
          default: "1.1em",
          desktop: "0.1em",
        },
      },
      text: {
        fontSize: {
          default: "1em",
          desktop: "1.2em",
        },
        lineHeight: {
          default: "1.3em",
          desktop: "1.467em",
        },
      },
    },
    screen: {
      paddingTop: {
        default: "2.7em",
        desktop: "0",
      },
    },
  },

  // Notification specific values
  notification: {
    block: {
      padding: "0.67em 1.33em",
      top: "-1.33em",
      width: "80%",
      left: "10%",
      borderRadius: "0.27em",
      boxShadow: "0.2em 0.67em 1.33em -0.40em rgb(94, 103, 98)",
    },
    text: {
      fontSize: {
        default: "1em",
        desktop: "1.27em",
      },
      paddingTop: {
        default: "0.33em",
        desktop: "0.26em",
      },
    },
  },

  // Loader specific values
  loader: {
    block: {
      padding: "2em",
      width: "32em",
    },
    animation: {
      width: "5rem",
      height: "5rem",
      borderWidth: "0.75rem",
    },
    text: {
      primary: {
        fontSize: "1.5em",
      },
      secondary: {
        fontSize: "1em",
        marginTop: "0.5em",
      },
    },
  },

  // Icon specific values
  icon: {
    title: {
      marginTop: "1.8em",
    },
    userVerified: {
      width: "1.5rem",
      height: "1.5rem",
    },
    copy: {
      left: "0.2em",
      top: "0.5em",
    },
    small: "0.9em", // 14.4px
    medium: "1.3em", // 20.8px
    large: "1.5em", // 24px
  },

  // Header specific values
  header: {
    paddingTop: "1.6em",
    paddingBottom: "1.1em",
    paddingTopMobile: "1.1em",

    userMenuNameFontSize: "1em",
    menuMarginTop: "1.1em",
    quotaLimitPadding: "1.5em",
    dividerMarginBottom: "0.5em",

    headerLeftGap: "2em",
    headerLeftGapMobile: "1em",
    headerRightGap: "2.2em",
    headerRightGapMobile: "1.2em",
  },

  // Heading specific values
  h1: {
    fontSize: "3em",
    marginTop: "0.1em",
  },

  // Footer specific values
  footer: {
    logo: {
      paddingRight: "0.55em",
      registeredMark: {
        fontSize: "1em",
        top: "38%",
      },
    },
    top: {
      padding: {
        top: "3em",
        bottom: "3.7em",
      },
      title: {
        fontSize: "1.2em",
        lineHeight: "1.2em",
        paddingBottom: "0.45em",
      },
      link: {
        fontSize: "1.1em",
        paddingBottom: "0.2em",
        minWidth: {
          default: "22rem",
          tablet: "20rem",
        },
        icon: {
          width: "1.27em",
          height: "1.5em",
        },
      },
      menu: {
        fontSize: "1em",
        gap: "1em",
      },
    },
    center: {
      padding: {
        top: "1.2em",
        bottom: "1.2em",
      },
      social: {
        padding: {
          left: "0.603125em",
          right: "0.603125em",
        },
        icon: {
          size: "2em",
          border: "0.25em",
        },
      },
      menu: {
        fontSize: "0.93em",
        separator: {
          marginLeft: "1em",
          top: "0.125em",
        },
      },
    },
    form: {
      message: {
        fontSize: "0.8em",
        bottom: "-1.6em",
      },
      input: {
        padding: {
          left: "0.7em",
          right: "0.7em",
        },
        maxWidth: "15em",
        fontSize: "0.9em",
        lineHeight: "1.1em",
        height: "2em",
      },
      submit: {
        padding: {
          top: "0.3em",
          bottom: "0.3em",
          left: "0.6em",
          right: "0.6em",
        },
        lineHeight: "1.2em",
      },
    },
    bottom: {
      padding: {
        top: "1.2em",
        bottom: "1.2em",
      },
      fontSize: "0.93em",
    },
  },

  // Content Blocks specific values
  contentBlocks: {
    white: {
      padding: "2.25em 2.5em 6.125em 2.625em",
    },
  },

  // Collection Window specific values
  collectionWindow: {
    fontSize: {
      small: "1em",
      medium: "1.2em",
      text: "1.2em",
      title: "1.5em",
    },
    lineHeight: {
      text: "1.5em",
      small: "1em",
    },
    margin: {
      bottom: {
        medium: "1em",
        large: "2em",
      },
    },
  },

  // Common component sizes
  button: {
    height: "2.62em", // 41.92px
    padding: "0.7em 1.712em 0.79em", // 11.2px 27.392px 12.64px
    fontSize: "1.07em", // 17.12px
    margin: "1.3em", // 20.8px
    icon: "1.3em", // 20.8px
    header: {
      borderRadius: "0.3em",
      fontSize: "1em",
      padding: "0.5em 1.8em",
      mobile: {
        height: "2.2em",
        padding: "0.2em .8em",
      },
    },
    tabs: {
      padding: "0.375em",
      borderRadius: "0.7em",
      item: {
        fontSize: "1em",
        padding: "1em",
        height: "2.667em",
        width: "9.333em",
        icon: {
          size: "1.2em",
          margin: "0.6em",
        },
        mobile: {
          padding: "0.2em",
          height: "2.2em",
          width: "5.6em",
          icon: {
            size: "0.8em",
          },
        },
      },
    },
  },
  input: {
    width: "23.33em", // 373.28px
    height: "2.8em", // 44.8px
    margin: "0.33em", // 5.28px
    number: {
      fontSize: "1em",
      marginTop: "1em",
    },
  },
  container: {
    padding: "1.75em", // 28px
    radius: "0.88em", // 14.08px
    gap: "2em", // 32px
    maxWidth: "73.75rem",
    width: {
      default: "calc(100% - 2.5em)",
      mobile: "calc(100% - 0.5em)",
    },
  },
  checkbox: {
    size: "0.93em", // 14.88px
    labelPadding: "0.2em", // 3.2px
  },
  dropdown: {
    width: "calc(100% - 2.4em)", // 38.4px offset
  },
  plusButton: {
    size: "1.5em", // 24px
    fontSize: "1.60em", // 25.6px
    margin: "0.17em", // 2.72px
  },
  general: {
    container: {
      borderRadius: "0.1em",
      width: "calc(100% - 3em)",
      maxWidth: "60rem",
    },
    stamp: {
      info: {
        icon: {
          width: "1.2em",
          margin: "0.2em",
        },
        padding: "0.53em 0.8em",
        radius: "0.27em",
        font: "0.8em",
      },
      found: {
        radius: "0.27em",
        margin: "1.33em",
        padding: "0.8em",
        icon: {
          width: "1.2em",
          large: "1.6em",
        },
        text: {
          fontSize: "0.8em",
          large: "1em",
        },
      },
      file: {
        margin: "1.33em",
        icon: "1.2em",
        font: "0.8em",
        padding: "0.2em",
      },
    },
    button: {
      icon: "1.2em",
      file: {
        icon: "0.2em",
      },
    },
  },
  modal: {
    content: {
      padding: "1.33em",
      radius: "0.27em",
    },
    header: {
      padding: "1.33em",
      radius: "0.27em",
    },
    body: {
      padding: "1.33em",
    },
    footer: {
      padding: "1.33em",
    },
    title: {
      fontSize: "1.5em",
      marginTop: "1em",
      marginBottom: "1em",
    },
  },
  accordion: {
    content: {
      padding: "1.33em",
    },
    item: {
      padding: "1.33em",
    },
    control: {
      padding: "1.33em",
    },
    label: {
      padding: "1.33em",
    },
  },

  common: {
    fontSize: {
      small: "0.93em",
      medium: "1.2em",
      large: "2.67em",
      xlarge: "2.8em",
    },
    lineHeight: {
      small: "0.57em",
      medium: "1.14em",
      large: "1.17em",
    },
    padding: {
      small: "0.1em",
      medium: "0.33em",
      large: "0.5em",
      xlarge: "1.2em",
    },
    margin: {
      small: "0.67em",
      medium: "1.2em",
      large: "2em",
      xlarge: "3.3em",
    },
    borderRadius: "0.57em",
  },
  pricing: {
    fontSize: {
      small: "0.93em",
      medium: "1.2em",
      large: "2.67em",
    },
    lineHeight: {
      small: "0.57em",
      medium: "1.14em",
    },
    padding: {
      small: "0.1em",
      large: "1.2em",
    },
    margin: {
      small: "0.67em",
      large: "2em",
    },
  },
  profile: {
    fontSize: {
      label: "1.2em",
      input: "1rem",
    },
    lineHeight: {
      input: "1.25rem",
    },
    padding: {
      right: "20px",
    },
    width: {
      label: "236px",
      input: "22rem",
    },
    accountSettings: {
      mfa: {
        active: {
          marginLeft: "1.4em",
        },
        inactive: {
          marginLeft: "0.4em",
        },
      },
    },
  },
  providers: {
    fontSize: {
      text: "1.2em",
      error: "0.9em",
      modal: "1.5em",
    },
    lineHeight: {
      error: "1em",
    },
    margin: {
      bottom: {
        list: "1em",
        item: "0.5em",
        button: "1.5em",
      },
      top: {
        modal: "1em",
      },
    },
    padding: {
      content: "1em",
      bottom: {
        heading: "1em",
        item: "1em",
      },
    },
    maxWidth: {
      text: "27em",
      content: "50em",
      input: "20em",
    },
    minHeight: {
      loader: "4em",
    },
    borderRadius: {
      content: "0.4em",
    },
  },
  reports: {
    fontSize: {
      title: "1.5em",
      content: "1.2em",
      value: "1.33em",
    },
    lineHeight: {
      key: "1.33em",
      value: "1.2em",
    },
    margin: {
      top: "2em",
      bottom: "0.39em",
    },
    padding: {
      block: "2.40em 2.67em 6.53em 2.80em",
      content: "1.07em 2.33em 1.33em 1.33em",
    },
    width: {
      main: "74em",
      content: "12.47em",
    },
    height: {
      content: "8.53em",
    },
    gap: {
      block: "1em",
      links: "2em",
    },
  },
  stamp: {
    fontSize: {
      title: "2.54em",
    },
    lineHeight: {
      title: "1.2em",
    },
    margin: {
      bottom: {
        title: "2.2em",
        block: "1.733em",
        headerText: "5.5em",
      },
      top: {
        title: "1.86em",
      },
    },
    padding: {
      top: {
        main: "6.5em",
        block: "0.667em",
        blockDesktop: "3.533em",
        bottom: "3.933em",
      },
      button: {
        left: "3em",
        right: "3em",
      },
    },
    width: {
      block: "calc(100% - 2.667em)",
      max: "46.133rem",
    },
    height: {
      button: "3em",
      scalloped: "2.067em",
    },
    background: {
      size: {
        scallopedTop: "2.387em 2em",
        scallopedSide: "2em 2.1em",
      },
    },
    position: {
      scalloped: {
        offset: "1.067em",
        left: "0.4em",
        top: "0.667em",
      },
    },
    text: {
      h1: {
        marginBottom: "0",
      },
      fileFoundHeaderLink: {
        marginTop: "1.5em",
        marginBottom: "3em",
        fontSize: "1.5em",
        maxWidth: "50em",
        gap: "0.8em",
        text: {
          fontSize: "1.5em",
          marginRight: "1em",
        },
        link: {
          fontSize: "1em",
          paddingLeft: "0.2em",
        },
        svg: {
          marginRight: "0.3em",
        },
      },
      fileFoundHeaderLinkWithoutLinkId: {
        marginBottom: "2.4em",
      },

      fileFoundPreview: {
        maxWidth: "50em",
        marginTop: "1.7em",
        container: {
          padding: "1em",
        },
        title: {
          fontSize: "1.5em",
        },
        content: {
          maxHeight: "20em",
          padding: "0.4em",
        },
        alert: {
          padding: "0 !important",
        },
      },
    },
    h2: {
      fontSize: "2em",
      marginBottom: "1em",
    },
    fileFoundHeader: {
      marginBottom: "1em",
      h1: {
        marginBottom: "0",
        lineHeight: "1em",
      },
    },
    duplicateStampWarning: {
      padding: "1em 1.2em",
      marginBottom: "2em",
      titleMarginBottom: "0.6em",
      fontSize: "1.1em",
      leadFontSize: "1em",
      lineHeight: "1.45em",
      iconSize: "1.5em",
      iconMarginTop: "0.12em",
    },
    fileFoundBlock: {
      maxWidth: "50em",
      h1: {
        fontSize: "2em",
      },
    },
    fileFoundBottom: {
      maxWidth: "50em",
      marginTop: "2.3em",
      title: {
        fontSize: "1.5em",
        marginBottom: "1em",
      },
      textLast: {
        marginTop: "5em",
      },
    },
    errorTechnicalDetails: {
      marginBottom: "1em",
    },
  },
  subscription: {
    fontSize: {
      header: "1em",
      title: "1.07em",
    },
    lineHeight: {
      title: "1.25em",
    },
    margin: {
      top: {
        title: "3em",
      },
      bottom: {
        title: "0.63em",
      },
    },
  },
  table: {
    margin: {
      bottom: "0.875em",
    },
    isPublic: {
      padding: {
        left: "1em",
      },
    },
    tolerance: {
      staticText: {
        paddingLeft: "1.2em",
        paddingRight: "1.2em",
        paddingTop: "0",
        paddingBottom: "0",
        fontSize: "1.2em",
      },
      bodyCell: {
        padding: "0.3em 1.28125em 0.25em 1.28125em",
        textAlign: "left",
        fontSize: "1.2em",
      },
      headCell: {
        padding: "0.2em 1.28125em 0.1em 1.28125em",
        textAlign: "left",
        fontSize: "1.2em",
        lineHeight: "1.36em",
      },
      totalBodyCell: {
        padding: "0",
        textAlign: "left",
      },
      totalHeadCell: {
        padding: "0.2em 1.28125em 0.1em 0",
        textAlign: "left",
        fontSize: "1.2em",
        lineHeight: "1.36em",
      },
    },
  },
  tabsTable: {
    fontSize: {
      tab: "1.2em",
      tabMobile: "1em",
    },
    margin: {
      bottom: {
        tabsList: "0.5em",
        select: "0.5em",
      },
    },
    width: {
      selectWrap: "67%",
      select: "25rem",
    },
    gap: {
      selectWrap: "1.5em",
      selectWrapMobile: "0.5em",
    },
  },
  technicalDetail: {
    fontSize: {
      title: "1.1em",
      key: "0.9em",
      value: "0.9em",
    },
    margin: {
      top: {
        main: "1em",
        item: "1em",
        download: "0.5em",
      },
      bottom: {
        stampTimeItem: "0.2em",
        value: "1em",
      },
      left: {
        dots: "0.2em",
      },
      right: {
        dots: "0.2em",
      },
    },
    padding: {
      block: {
        left: "1em",
        right: "1em",
        top: "0.5em",
      },
      value: {
        right: "0.2em",
      },
      showHide: {
        left: "1.2em",
      },
    },
    width: {
      max: "40em",
    },
    position: {
      dots: {
        bottom: "0.6em",
      },
    },
    divider: {
      marginBottom: "0.7em",
      paddingBottom: "1em",
    },
    item: {
      maxHeight: "1.6em",
    },
    alert: {
      marginBottom: "1em",
      padding: "0",
    },
  },
  tipTapEditor: {
    width: {
      editor: "23.47em",
      editorMobile: "16.3em",
    },
    padding: {
      toolbar: "0.2em",
      content: "0.2em",
    },
    gap: {
      toolbar: "0.2em",
    },
    size: {
      button: {
        minWidth: "1.5em",
        height: "1.5em",
      },
      icon: {
        width: "1em",
        height: "1em",
      },
    },
    height: {
      content: "8em",
    },
  },
  tooltip: {
    padding: {
      bottom: "0.5em",
    },
    size: {
      button: {
        width: "2.5em",
        height: "2.5em",
        minWidth: "2.5em",
        minHeight: "2.5em",
      },
      icon: {
        width: "1.8em",
        height: "1.8em",
      },
    },
    border: {
      width: "0.5px",
    },
  },
  triggerHelp: {
    position: {
      right: "1.2em",
      bottom: "1.5em",
    },
    padding: {
      main: "0.3em",
    },
    borderRadius: "0.2em",
    arrow: {
      bottom: "-0.4em",
      left: "calc(50% - 0.2em)",
      size: "0.4em",
    },
    switch: {
      margin: {
        top: "0.5em",
        bottom: "0.4em",
      },
    },
  },
  userContent: {
    fontSize: "1.1em",
    list: {
      paddingLeft: "1em",
    },
    blockFlex: {
      gap: "0.5em",
      left: {
        width: "calc(100% - 9.033em)",
      },
      right: {
        width: "8.533em",
        marginTop: "1em",
      },
    },
  },
  userFound: {
    fontSize: {
      key: "1.2em",
      value: "1.1em",
    },
    maxWidth: {
      blockChainAddress: "100",
    },
  },
  userInputBlock: {
    breakpoint: "509px",
  },
  userTabContent: {
    padding: {
      top: "5rem",
      bottom: "6rem",
    },
    heading: {
      h2: {
        paddingBottom: "2rem",
        fontSize: "3em",
      },
      h3: {
        paddingBottom: "2rem",
        fontSize: "1.5em",
      },
    },
  },

  fileManager: {
    toolbarMinHeight: "3.5em",
    h2FontSize: "1.3em",
    paperMinWidth: "45em",
    keyMinWidth: "5em",
    folderNameWidthOffset: "2em",
    folderIconSize: "1.5em",
    breadcrumbHeight: "2em",
    fileTextFontSize: "1.2em",
    linkGap: "0.5em",
  },

  modalCreate: {
    contentMaxWidth: "65em",

    titleFontSize: "1.47em",
    titleMarginBottom: "0.23em",
    titleMarginTop: "0.7em",

    textFontSize: {
      default: "0.93em",
      desktop: "1em",
    },
    textMarginTop: "0.71em",

    confirmationTitleMarginTop: "1.36em",
    confirmationTitleMarginBottom: "0.9em",
    previewMaxHeight: "9em",
  },

  borderedContent: {
    marginTop: "0.67em",
    maxWidth: "50em",
    marginXMobile: "1em",
    maxWidthMobile: "calc(100% - 2em)",
    shadowOffset: "0.67em",
    shadowBlur: "2.66em",
    padding: {
      top: "4.8em",
      bottom: "3.4em",
      sides: "3.13em",
    },
    borderDotSize: "0.53em",
    tooltipOffset: {
      top: "2em",
      right: "1.98em",
    },
    keyFontSize: "1.07em",
    valueFontSize: "1.2em",
    innerFontSize: "1em",
    userValue: {
      lineHeight: "1.25em",
      marginBottom: "0.2em",
      rowGap: "0.1em",
    },
    changeFlag: {
      dotBottomOffset: "0.09em",
      dotFontSize: "1.6em",
      dotLineHeight: "0",
      dotMarginRight: "0.2em",
      fontSize: "0.9em",
      lineHeight: "1.25em",
      lineHeightMobile: "2em",
      valueFontSize: "0.75em",
      paddingLeft: "0.5em",
      paddingLeftMobile: "0",
    },
    timeDelta: {
      fontSize: "0.93em",
      padding: "0.4em 0.8em 0.3em",
      marginLeft: "0.5em",
      marginTop: "-0.1em",
      topOffset: "-0.2em",
      borderRadius: "0.5em",
    },
    date: {
      paddingBottom: "2em",
      marginBottom: "1em",
    },
  },
  borderedContentNot: {
    padding: {
      top: "2.8em",
      bottom: "3.6em",
    },
  },

  collectionSelect: {
    paddingTop: "2em",
    paddingBottom: "1.33em",
    maxWidth: "44.87em",
    width: "calc(100% - 3em)",
    checkbox: {
      size: "0.93em",
      iconWidth: "45%",
      labelPadding: "0.2em",
      labelFontSize: "1.075em",
    },
    dropdown: {
      width: "calc(100% - 2.4em)",
      separatorRight: "2.13em",
      iconRight: "0.8em",
      arrowLeft: "0.33em solid transparent",
      arrowRight: "0.33em solid transparent",
      arrowTop: "0.53em solid #000",
      arrowTopDisabled: "0.53em solid hsla(0, 0%, 44%, 0.4)",
    },
    plus: {
      width: "1.5em",
      height: "1.5em",
      border: "1px solid hsla(0,0%,44%,.4)",
      borderRadius: "0.17em",
      fontSize: "1.60em",
      marginLeft: "0.17em",
    },
  },

  stampTabContentGeneral: {
    tooltipTop: "-3.5em",
    wrapContentPaddingTop: "1.87em",
    borderRadius: "0.1em",
    dashedBorder: "1px dashed rgba(112, 112, 112, 0.5)",
    wrapContentContainerWidthOffset: "3em",
    wrapContentContainerMaxWidth: "60rem",
    wrapContentContainerPaddingTop: "6.7em",
    wrapContentContainerPaddingBottom: "6.7em",
    wrapContentContainerPaddingStampTop: "6.7em",
    wrapContentContainerPaddingStampBottom: "6.7em",
    wrapContentContainerNoHashGap: "2em",
    // Dropzone specific values
    dropzonePadding: "0 1.2em 1.2em 1.2em",
    dropzoneDisplay: "flex",
    dropzoneJustifyContent: "center",
    dropzoneTextAlign: "center",
    dropzoneCursor: "pointer",
    // Dropzone content specific values
    dropzoneGroupDisplay: "block",
    dropzoneGroupPointerEvents: "none",
    dropzoneButtonPaddingLeftMobile: ".25em",
    dropzoneButtonPaddingRightMobile: ".25em",
    dropzoneButtonPaddingLeftDesktop: "1.25em",
    dropzoneButtonPaddingRightDesktop: "1.25em",
    dropzoneIconSize: "3.25em",
    dropzoneTextPadding: "0",
    dropzoneTextFontSize: "0.9em",
    dropzoneTextMaxWidth: "calc(100% - 4rem)",
    dropzoneSubTextPaddingTop: "0.5em",
    dropzoneSubTextPaddingBottom: "0",
    dropzoneSubTextFontSize: "1em",
    dropzoneSubText2PaddingTop: "0.625em",
    dropzoneSubText2FontSize: "1em",
    dropzoneRemoveIconSize: "1.125em",
    dropzoneRemoveIconMarginLeft: "0.5em",
    // S3 sections specific values
    s3SectionPadding: "2rem",
    s3SectionBorder: "2px dashed #ccc",
    s3SectionBorderRadius: "8px",
    s3SectionTextAlign: "center",
    s3SectionBackgroundColor: "#f9f9f9",
    s3IconSize: "48px",
    s3IconColor: "#000000",
    s3TitleFontSize: "1.125em",
    s3TitleFontWeight: 500,
    s3DescFontSize: "0.875em",
    s3DescColor: "#868e96",
    s3FormGap: "0.625em",
    s3InputWidth: "100%",
    // Non-authenticated section
    nonAuthSectionMinHeight: "17.3rem",
    nonAuthSectionMaxWidth: "22rem",
    nonAuthSectionPaddingTop: "4.6rem",
    // Dropzone content box
    dropzoneContentBoxPaddingTop: "6em",
    dropzoneContentBoxPaddingBottom: "4em",
    // Anchor pointer events
    anchorPointerEvents: "auto",
    // Resource type buttons specific values
    resourceTabButtonFontSize: "1em",
    resourceSubmitButtonFontSize: "1em",
    // RingProgress specific values
    ringProgressContainerPaddingTop: "0.5em",
    ringProgressLabelFontWeight: 500,
    ringProgressLabelTextAlign: "center",
    inputWidth: "23.33em",
    inputHeight: "2.8em",
    inputFontSize: "1em",
    inputMarginTop: "0.33em",
    buttonPadding: "0.7em 1.712em 0.79em !important",
    buttonFilledPadding: "0.9em 3.712em 0em 0em !important",
    buttonFilledMargin: "0 !important",
    buttonFilledMobileMargin: "2em !important",
    buttonFontSize: "1.07em !important",
    buttonMarginTop: "1.3em !important",
    buttonHeight: "2.62em",
    buttonPaddingLeft: "2em !important",
    buttonSvgWidth: "1.3em !important",
    infoFileTabPadding: "1.75em",
    previewPadding: "1em",
    infoFileTabBorderRadius: "0.88em",
    infoFileTabFontSize: "1.07em",
    infoFileTabImgWidth: "1.31em",
    infoFileTabImgMarginRight: "0.63em",
    fileDropzoneFontSize: "1.07em",
    fileDropzoneLineHeight: "1.25em",
    fileDropzoneMarginTop: "2em",
    buttonFileWidth: "13.333em",
    buttonFileHeight: "3.863em",
    buttonFileSvgMarginRight: "0.53em",
    buttonFileHashFontSize: "0.93em !important",
    buttonFileHashMarginBottom: "1em",
    buttonStampFontSize: "1.07em",
    buttonStampWidth: "16.13em",
    buttonStampHeight: "2.45em",
    stampFoundInfoBorderRadius: "0.13em",
    stampFoundInfoMarginBottom: "0.67em",
    stampFoundInfoWidthOffset: "3em",
    stampFoundInfoMaxWidth: "60rem",
    stampFoundInfoImgPaddingTop: "1.07em",
    stampFoundInfoImgPaddingBottom: "1.09em",
    stampFoundInfoImgPaddingLeft: "0.9em",
    stampFoundInfoImgPaddingRight: "0.97em",
    stampFoundInfoImgWidth: "1.47em",
    stampFoundInfoImgWidthDesktop: "2.13em",
    stampFoundInfoTextPaddingLeft: "1.17em",
    stampFoundInfoTextFontSize: "0.8em",
    stampFoundInfoTextLineHeight: "1.25em",
    stampFoundInfoTextPaddingLeftDesktop: "1.38em",
    stampFoundInfoTextFontSizeDesktop: "1.07em",
    stampFoundInfoTextLineHeightDesktop: "1.25em",
    stampFileLoadedMarginBottom: "1.33em",
    stampFileLoadedImgWidth: "2.84em",
    stampFileLoadedSpanFontSize: "1.2em",
    stampFileLoadedSpanPaddingLeft: "0.56em",
    stampDragTextFontSize: "1.07em",
    stampDragTextLineHeight: "1.25em",
    stampHashBottom: "0.81em",
    stampHashLeft: "0.94em",
    stampHashFontSize: "1.07em",
    stampHashPaddingRight: "1.88em",
    stampHashFontSizeMobile: "0.9em",
    stampHashTextPaddingRight: "0.3em",
    stampHashActionIconMarginLeft: "0.47em",
    stampHashActionIconMarginTop: "-0.13em",
    stampInfoPadding: "1.75em",
    stampInfoBorderRadius: "0.88em",
    stampInfoFontSize: "1.07em",
    stampInfoImgWidth: "1.4em",
    stampInfoImgMarginRight: "0.67em",
    stampFromHashInputBorder: "1px solid hsla(0,0%,44%,.502)",
    stampFromHashInputBorderRadius: "0.27em",
    stampFromHashInputFontSize: "1rem",
    stampFromHashInputHeight: "2.62em",
    stampFromHashInputLineHeight: "1.25rem",
    stampFromHashInputPadding: ".75rem 1rem",
    stampFromHashInputPaddingRight: "2.2em",
    stampFromHashInputWrapPadding: "2.6em 1.8em 1.33em 1.87em",
    stampFromHashInputImgWidth: "1.47em",
    stampFromHashInputImgRight: "0.67em",
    stampFromHashInputImgTop: "0.65em",
    stampFromHashInputImgRightMobile: "2.5em",
    stampFromHashInputImgTopMobile: "3.25em",
    stampFromHashInputInvalidTextMarginTop: "0.33em",
    stampFromHashContainerWidthOffset: "2.67em",
    stampFromHashContainerMaxWidth: "64.27em",
    stampHashMobileLoginMarginTop: "1em",
    stampHashTextMarginTop: "2em",
    stampHashTextMarginBottom: "0.33em",
    stampHashTextMaxWidth: "19em",
    stampHashTextImgWidth: "1.67em",
    stampHashTextImgMarginRight: "0.5em",
    stampHashTextFontSize: "1.07em",
    stampHashTextLineHeight: "1.25em",
    stampBulkTextMarginTop: "2.21em",
    stampBulkTextMarginBottom: "-2em",
    stampBulkTextFontSize: "0.93em",
    stampBulkTextLineHeight: "1.21em",
    stampBulkTextPaddingTop: "0.93em",
    stampBulkTextPaddingBottom: "0.86em",
    stampBulkTextMarginLeft: "1.43em",
    stampBulkTextMarginRight: "1.43em",
    stampBulkTextMaxWidth: "calc(100% - 2.86em)",
    stampBulkTextMarginBottomDesktop: "0.94em",
    stampBulkTextFontSizeDesktop: "1.29em",
    stampBulkTextLineHeightDesktop: "1.22em",
    stampBulkTextPaddingDesktop: "0.56em 1.89em",
    stampBulkTextMaxWidthDesktop: "27.78em",
    tiptop: {
      minHeight: "8em",
      padding: "0.5em",
    },
    portfolio: {
      textarea: {
        minHeight: "15em",
        minHeightMobile: "18em",
      },
      placeholder: {
        padding: {
          top: "0.5em",
          bottom: "0.5em",
          left: "1em",
          right: "1em",
        },
        gap: "0.25em",
        p: {
          lineHeight: "0.9em",
        },
        strong: {
          lineHeight: "0.8em",
        },
        ul: {
          paddingBottom: "0.9em",
        },
        li: {
          lineHeight: "1.1em",
        },
      },
    },
  },

  accordionNew: {
    itemBorderRadius: "0.2em",
    controlPaddingRight: "0",
    controlSvgStrokeWidth: "3 !important",
    chevronRight: "3.47em",
    chevronZIndex: 1,
    showHideFontSize: "0.93em",
    showHideMarginLeft: "auto",
    showHidePaddingTop: "0.2em",
    showHideZIndex: 1,
    showHideBoxWidth: "5.47em",
    showHideBoxHeight: "100%",
    showHideBoxRight: "0",
    showHideBoxTop: "0",
    showHideBoxBorderRadius: "0.2em",
    showTextLeft: "0.35em",
  },

  helpVideo: {
    top: "6.8em",
    marginRight: "1.333em",
    padding: "0.4em",
    width: "2.4em",
    height: "2.4em",

    topTabletSmall: "10.6em",
    marginRightTabletSmall: "0.667em",

    iconSize: "1.533em",
    closeRight: "0.6em",
    closeTop: "0.533em",
    textPaddingTop: "0.667em",

    activeWidth: "14.333em",
    activeHeight: "7.267em",
    activePadding: "1.067em 0.6em 0.8em 1.067em",

    activeWidthTablet: "13.667em",
    activeHeightTablet: "9em",
    activeTopTablet: "5.8em",

    beforeLeft: "-0.867em",
    afterLeft: "-0.733em",

    iconSizeActive: "2.067em",
    textFontSize: "0.933em",
    textLineHeight: "1.2em",
  },
  infoBanner: {
    padding: "0.2em",
  },
};
